import React from "react";

export const APICredentialDetailContext = React.createContext(null);

export const useAPICredentialDetailContext = () => {
  const context = React.useContext(APICredentialDetailContext);
  if (!context) throw new Error("APICredentialDetailContext not provided!");
  return context;
};
